import { render, staticRenderFns } from "./createorganization.vue?vue&type=template&id=2ee34ad2"
import script from "./createorganization.vue?vue&type=script&lang=js"
export * from "./createorganization.vue?vue&type=script&lang=js"
import style0 from "./createorganization.vue?vue&type=style&index=0&id=2ee34ad2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports